export enum Collection {
    Races = 'races',
    Events = 'events',
    Entries = 'entries',
    Users = 'users',
}